export enum ELoginAs {
  LIVE = 'LIVE',
  MT4_LIVE = 'MT4_LIVE',
  MT4_DEMO = 'MT4_DEMO',
  MT5_LIVE = 'MT5_LIVE',
  MT5_DEMO = 'MT5_DEMO',
  OMS_DEMO = 'OMS_DEMO',
  OMS_LIVE = 'OMS_LIVE'
}

export const SWITCH_ACCOUNT_KEY = 'switch_account';

export const DEMO_LOGINS = [ELoginAs.MT4_DEMO, ELoginAs.MT5_DEMO, ELoginAs.OMS_DEMO];

export const LIVE_LOGINS = [ELoginAs.LIVE, ELoginAs.MT4_LIVE, ELoginAs.MT5_LIVE, ELoginAs.OMS_LIVE];

export const LIVE_LOGINS_WITHOUT_CRM = [ELoginAs.MT4_LIVE, ELoginAs.MT5_LIVE, ELoginAs.OMS_LIVE];
